import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
	const { user, isCheckingAuth } = useAuth();
	const location = useLocation();

	const hasEnvToken = !!process.env.REACT_APP_BACKEND_TOKEN;

	if (hasEnvToken) return children;

	if (isCheckingAuth) return null;

	if (user) return children;

	const redirectTo = encodeURIComponent(
		location.pathname + location.search || "/"
	);
	return <Navigate to={`/login?redirectTo=${redirectTo}`} replace />;
};

export default ProtectedRoute;
